import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import api from "../../../services/axiosInstance";
import GenericReportPage from "../../../components/common/GenericReportPage";
import { fmtQty } from "../../../utils/reportExport";

const LowStockReport = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        let mounted = true;
        api.get('/inventory/category/list.php?page=1&limit=100&active_only=1')
            .then((res) => { if (mounted) setCategories(res.data.dataset || []); })
            .catch(() => { /* Non-critical */ });
        return () => { mounted = false; };
    }, []);

    return (
        <GenericReportPage
            title="Low Stock Report"
            subtitle="Active items at or below their reorder level"
            breadcrumb={["Reports", "Inventory"]}
            fetchUrl="/reports/inventory/low_stock.php"
            rowKey="invi_id"
            filterDefs={[
                { type: "search", key: "search", label: "Search", col: 7, placeholder: "Code, item name" },
                {
                    type: "select", key: "ic_id", label: "Category", col: 6,
                    options: categories.map((c) => ({ value: c.ic_id, label: c.ic_name })),
                    showSearch: true,
                },
            ]}
            columns={[
                { title: 'Item Code', dataIndex: 'inv_code', key: 'inv_code', width: 120, sorter: (a, b) => (a.inv_code || '').localeCompare(b.inv_code || '') },
                { title: 'Item Name', dataIndex: 'item_name', key: 'item_name', sorter: (a, b) => (a.item_name || '').localeCompare(b.item_name || '') },
                { title: 'Category', dataIndex: 'category_name', key: 'category_name', render: (v) => v || <Typography.Text type="secondary">—</Typography.Text> },
                { title: 'Available Qty', dataIndex: 'available_qty', key: 'available_qty', align: 'right', width: 120, sorter: (a, b) => (a.available_qty || 0) - (b.available_qty || 0), render: (v) => <span style={{ color: "#cf1322", fontWeight: 600 }}>{fmtQty(v)}</span> },
                { title: 'Reorder Qty', dataIndex: 'reorder_qty', key: 'reorder_qty', align: 'right', width: 110, render: (v) => fmtQty(v) },
                { title: 'Shortage', dataIndex: 'shortage_qty', key: 'shortage_qty', align: 'right', width: 100, sorter: (a, b) => (a.shortage_qty || 0) - (b.shortage_qty || 0), render: (v) => fmtQty(v) },
                { title: 'UOM', dataIndex: 'uom_name', key: 'uom_name', width: 80, render: (v) => v || <Typography.Text type="secondary">—</Typography.Text> },
            ]}
            pdf={{
                title: "LOW STOCK REPORT",
                subtitle: "Active items at or below their reorder level",
                columns: [
                    { header: "Item Code" }, { header: "Item Name" }, { header: "Category" },
                    { header: "Available Qty", align: "right" }, { header: "Reorder Qty", align: "right" },
                    { header: "Shortage", align: "right" }, { header: "UOM" },
                ],
                rows: (rows) =>
                    rows.map((r) => [
                        r.inv_code || "-",
                        r.item_name || "-",
                        r.category_name || "—",
                        fmtQty(r.available_qty),
                        fmtQty(r.reorder_qty),
                        fmtQty(r.shortage_qty),
                        r.uom_name || "-",
                    ]),
                summary: (rows) => [
                    { label: "Items Below Reorder Level:", value: String(rows.length) },
                ],
                columnStyles: { 3: { halign: "right" }, 4: { halign: "right" }, 5: { halign: "right" } },
            }}
            excel={{
                filename: "low-stock-report",
                sheetName: "Low Stock",
                columns: [
                    { title: "Item Code", dataIndex: "inv_code", width: 14 },
                    { title: "Item Name", dataIndex: "item_name", width: 30 },
                    { title: "Category", dataIndex: "category_name", width: 20 },
                    { title: "Available Qty", dataIndex: "available_qty", width: 12 },
                    { title: "Reorder Qty", dataIndex: "reorder_qty", width: 12 },
                    { title: "Shortage", dataIndex: "shortage_qty", width: 10 },
                    { title: "UOM", dataIndex: "uom_name", width: 8 },
                ],
                rows: (rows) =>
                    rows.map((r) => ({
                        ...r,
                        available_qty: fmtQty(r.available_qty),
                        reorder_qty: fmtQty(r.reorder_qty),
                        shortage_qty: fmtQty(r.shortage_qty),
                    })),
            }}
        />
    );
};

export default LowStockReport;
